import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';

type EquityMarketAdminPanelHeaderProps = {
  societyId: string;
  societyName: string;
};

const EquityMarketAdminPanelHeader: FC<EquityMarketAdminPanelHeaderProps> = ({
  societyId,
  societyName,
}) => {
  const { t } = useTranslate();
  const location = useLocation();
  const partnerQuery = new URLSearchParams(location.search).get('partnerId');
  const pq = partnerQuery ? `?partnerId=${partnerQuery}` : '';

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: societyName, to: `/sociedad/${societyId}` },
      {
        label: t('EquityMarket'),
        to: `/mercado-de-acciones/${societyId}${pq}`,
      },
      { label: t('AdminPanel'), isActive: true },
    ],
    [t, societyName, societyId, pq]
  );

  return (
    <>
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="nk-block-head page-header-subtitle">
        <div className="nk-block-between">
          <div className="nk-block-head-content">
            <h3 className="nk-block-title page-title">
              {t('AdminPanel')}
              <span className="badge badge-outline badge-primary ml-2">
                {t('Admin')}
              </span>
            </h3>
            <div className="nk-block-des text-soft">
              <p>{t('EquityAdminPanelDescription')}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EquityMarketAdminPanelHeader;
